// import axios from 'axios'
import { post, put, get, remove } from '@/api/api'

export const actions = {
  fetchPrixs({ commit }) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/details`).then(({ data }) => {
      commit("addPrixs", data);
    });
  },
  async fetchfetchPrix({ commit }, params = {}) {
    const { page = 0, size = 10, sort = '' } = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort,
    }).toString();

    let { data } = await get(`/canal/details/page?${queryParams}`);
    commit("addPrixsPage", data)
    return data;
  },
  createPrix({ commit }, prix) {
    return post("/canal/details", prix).then(({ data }) => {
      commit("addPrix", data);
    });
  },
  updatePrix({ commit }, prix) {
    return put(`/canal/details/${prix.id}`, prix).then(({ data }) => {
      commit("replacePrix", data);
    });
  },
  createOrUpdatePrix({ dispatch }, prix) {
    if (prix.id !== undefined) {
      return dispatch('updatePrix', prix)
    } else {
      return dispatch('createPrix', prix)
    }
  },
  detetePrix({ commit }, prix) {
    return remove(`/canal/details/${prix.id}`)
      .then(({ data }) => {

      })
  },
  selectPrix({ commit }, prix) {
    commit('setPrix', prix)
  }
}
